import '../../../vendor/clippy/clippy';

const hasHadIntro = localStorage.getItem('introComplete');
const userAgeentRX = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i;

const isIframe = new URL(location.href).searchParams.get('iframe_embed');

window.onload = function() {
  if (
    JSON.parse(hasHadIntro) ||
    userAgeentRX.test(navigator.userAgent) ||
    JSON.parse(isIframe)
  )
    return;

  const target = document.querySelector('.placeholder-card > h5');
  const coords = getOffset(target);

  clippy.load('Clippy', function(agent) {
    agent.moveTo(coords.left, coords.top);
    agent.show();

    const stepRunner = enqueueSteps(agent);

    agent.play('GetAttention');
    stepRunner(walkThrough);
  });
};

function getOffset(el) {
  const rect = el.getBoundingClientRect();
  return {
    left: Math.round(rect.left + window.scrollX),
    top: Math.round(rect.top + window.scrollY)
  };
}

function enqueueSteps(agent) {
  let counter = 0;
  return function getStep(steps) {
    if (steps.stepText) {
      setTimeout(() => {
        agent.speak(steps.stepText);
        steps.animation && agent.play(steps.animation);
        getStep(steps.next);
      }, (counter += steps.delay));
    } else {
      setTimeout(() => {
        agent.hide();
        localStorage.setItem('introComplete', true);
        console.log('End');
      }, counter - 1500);
      return;
    }
  };
}

const walkThrough = {
  stepText: `Hey there! Remember me?`,
  animation: '',
  delay: 1600,
  next: {
    stepText: `James has revived me from depths of the 90's to welcome you to the Progress Tracker!`,
    animation: '',
    delay: 2500,
    next: {
      stepText: `Here, you can check on the status of your task and pin 📌  it for later!`,
      animation: 'Save',
      delay: 1700,
      next: {
        stepText: `If you get stuck, you can read the FAQ article on The Hub 💭.`,
        animation: 'CheckingSomething',
        delay: 1700,
        next: {
          stepText: `The link is in the nav 🔗`,
          animation: 'GestureUp',
          delay: 900,
          next: {
            stepText: `I'll leave you too it... See you in another 20 years!🎈`,
            animation: 'Congratulate',
            delay: 2500,
            next: {
              stepText: null
            }
          }
        }
      }
    }
  }
};
